import {NgIf} from '@angular/common';
import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NbButtonModule, NbIconModule} from '@nebular/theme';
import {FormlyModule} from '@ngx-formly/core';
import {TuiLabel, TuiTextfield, TuiTextfieldComponent, TuiTextfieldOptionsDirective} from '@taiga-ui/core';
import {TuiCalendarRange, TuiInputDateRangeDirective} from '@taiga-ui/kit';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  standalone: true,
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  imports: [
    FormsModule,
    FormlyModule,
    ReactiveFormsModule,
    TuiCalendarRange,
    TuiInputDateRangeDirective,
    TuiLabel,
    TuiTextfieldComponent,
    TuiTextfieldOptionsDirective,
    TuiTextfield,
    NgIf,
    NbButtonModule,
    NbIconModule,
  ],
})
export class DateRangePickerComponent extends BaseFieldType {
}
